import { useEffect, useRef, useState } from "react";
import { X, Timer } from "lucide-react";

const playBeep = (ctxRef) => {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    const ctx = ctxRef.current || new Ctx();
    ctxRef.current = ctx;
    if (ctx.state === "suspended") ctx.resume();
    [0, 0.28, 0.56].forEach((t, i) => {
      const o = ctx.createOscillator();
      const g = ctx.createGain();
      o.connect(g);
      g.connect(ctx.destination);
      o.frequency.value = i === 2 ? 1318 : 880;
      g.gain.setValueAtTime(0.001, ctx.currentTime + t);
      g.gain.exponentialRampToValueAtTime(0.35, ctx.currentTime + t + 0.02);
      g.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + t + 0.24);
      o.start(ctx.currentTime + t);
      o.stop(ctx.currentTime + t + 0.26);
    });
  } catch (e) {
    console.warn("Bip du minuteur impossible:", e?.message);
  }
};

export const RestTimer = ({ seconds, onDone }) => {
  const [left, setLeft] = useState(seconds);
  const ctxRef = useRef(null);

  useEffect(() => setLeft(seconds), [seconds]);

  useEffect(() => {
    try {
      const Ctx = window.AudioContext || window.webkitAudioContext;
      if (!ctxRef.current) ctxRef.current = new Ctx();
      if (ctxRef.current.state === "suspended") ctxRef.current.resume();
    } catch (e) {
      console.warn("AudioContext indisponible:", e?.message);
    }
    return () => { ctxRef.current?.close().catch(() => {}); };
  }, []);

  useEffect(() => {
    if (left <= 0) {
      if (navigator.vibrate) navigator.vibrate([300, 100, 300, 100, 500]);
      playBeep(ctxRef);
      onDone();
      return;
    }
    const t = setTimeout(() => setLeft(left - 1), 1000);
    return () => clearTimeout(t);
  }, [left, onDone]);

  const mm = String(Math.floor(left / 60)).padStart(2, "0");
  const ss = String(left % 60).padStart(2, "0");
  const pct = seconds > 0 ? (left / seconds) * 100 : 0;

  return (
    <div data-testid="rest-timer" className="fixed bottom-[72px] left-0 right-0 z-50">
      <div className="max-w-md mx-auto px-4">
        <div className="bg-[#14141A] border border-[#32D74B]/40 flex items-center gap-4 px-4 py-3 relative overflow-hidden">
          <div className="absolute bottom-0 left-0 h-[3px] bg-[#32D74B] transition-all duration-1000 ease-linear" style={{ width: `${pct}%` }} />
          <span className="text-[10px] uppercase tracking-widest text-[#B0B0B4] flex items-center gap-1.5">
            <Timer size={16} className="text-[#32D74B]" /> Repos
          </span>
          <span className="font-mono text-3xl text-[#32D74B] font-bold flex-1" data-testid="rest-timer-countdown">{mm}:{ss}</span>
          <button data-testid="rest-timer-skip-button" onClick={onDone}
            className="text-[#B0B0B4] hover:text-white p-2 transition-colors" aria-label="Passer">
            <X size={20} />
          </button>
        </div>
      </div>
    </div>
  );
};
